// AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// This file exports all available translations for i18next

import TRANSLATE_AR from "./ar/translations.json";
import TRANSLATE_BG from "./bg/translations.json";
import TRANSLATE_CA from "./ca/translations.json";
import TRANSLATE_CS from "./cs/translations.json";
import TRANSLATE_DA from "./da/translations.json";
import TRANSLATE_DE from "./de/translations.json";
import TRANSLATE_EL from "./el/translations.json";
import TRANSLATE_EN from "./en/translations.json";
import TRANSLATE_ES from "./es/translations.json";
import TRANSLATE_ET from "./et/translations.json";
import TRANSLATE_FA from "./fa/translations.json";
import TRANSLATE_FI from "./fi/translations.json";
import TRANSLATE_FR from "./fr/translations.json";
import TRANSLATE_HR from "./hr/translations.json";
import TRANSLATE_HU from "./hu/translations.json";
import TRANSLATE_IT from "./it/translations.json";
import TRANSLATE_JA from "./ja/translations.json";
import TRANSLATE_KA from "./ka/translations.json";
import TRANSLATE_KO from "./ko/translations.json";
import TRANSLATE_LT from "./lt/translations.json";
import TRANSLATE_NO from "./no/translations.json";
import TRANSLATE_PL from "./pl/translations.json";
import TRANSLATE_PT from "./pt/translations.json";
import TRANSLATE_RO from "./ro/translations.json";
import TRANSLATE_RU from "./ru/translations.json";
import TRANSLATE_SK from "./sk/translations.json";
import TRANSLATE_SV from "./sv/translations.json";
import TRANSLATE_TR from "./tr/translations.json";
import TRANSLATE_UK from "./uk/translations.json";
import TRANSLATE_ZH_CN from "./zh_CN/translations.json";
import TRANSLATE_ZH_TW from "./zh_TW/translations.json";
import TRANSLATE_GA from "./ga/translations.json";

export const translations = {
  ga: { translation: TRANSLATE_GA },
  ar: { translation: TRANSLATE_AR },
  bg: { translation: TRANSLATE_BG },
  ca: { translation: TRANSLATE_CA },
  cs: { translation: TRANSLATE_CS },
  da: { translation: TRANSLATE_DA },
  de: { translation: TRANSLATE_DE },
  el: { translation: TRANSLATE_EL },
  en: { translation: TRANSLATE_EN },
  es: { translation: TRANSLATE_ES },
  et: { translation: TRANSLATE_ET },
  fa: { translation: TRANSLATE_FA },
  fi: { translation: TRANSLATE_FI },
  fr: { translation: TRANSLATE_FR },
  hr: { translation: TRANSLATE_HR },
  hu: { translation: TRANSLATE_HU },
  it: { translation: TRANSLATE_IT },
  ja: { translation: TRANSLATE_JA },
  ka: { translation: TRANSLATE_KA },
  ko: { translation: TRANSLATE_KO },
  lt: { translation: TRANSLATE_LT },
  no: { translation: TRANSLATE_NO },
  pl: { translation: TRANSLATE_PL },
  pt: { translation: TRANSLATE_PT },
  ro: { translation: TRANSLATE_RO },
  ru: { translation: TRANSLATE_RU },
  sk: { translation: TRANSLATE_SK },
  sv: { translation: TRANSLATE_SV },
  tr: { translation: TRANSLATE_TR },
  uk: { translation: TRANSLATE_UK },
  zh_CN: { translation: TRANSLATE_ZH_CN },
  zh_TW: { translation: TRANSLATE_ZH_TW },
};
